<template>
  <div class="modal shared-step-editor-modal" :class="open ? 'show' : 'hide'" @click.self="$emit('close')">
    <div :style="{width: modalWidth}" class="modal-dialog shared-step-editor-modal__dialog" role="document">
      <div class="modal-content">
        <div class="modal-header shared-step-editor-modal__header">
          {{ title }}
          <button
            type="button"
            class="close shared-step-editor-modal__close"
            @click="$emit('close')"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body shared-step-editor-modal__body"><slot /></div>
        <div class="modal-footer">
          <button v-if="closeText" type="button" class="btn shared-step-editor-modal__button" @click="$emit('close')">
            {{ closeText }}
          </button>
          <button v-if="confirmText" type="button" class="btn btn-primary" @click="$emit('confirm')">
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    open: Boolean,
    title: String,
    closeText: String,
    confirmText: String,
    width: {
      type: Number,
      default: 598,
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
  },
  computed: {
    modalWidth() {
      return this.width + 'px';
    },
  },
};
</script>

<style lang="scss">
@import '../../../../../sass/web/_variables.scss';

.shared-step-editor-modal {
  background: rgba(0, 0, 0, 0.5);
  text-align: left;
  z-index: 2000;
  &__dialog {
    top: 50%;
    transform: translateY(-50%);
  }
  &__header {
    font-size: 26px;
    line-height: 30px;
    font-weight: 600;
    color: #43454b;
    text-align: left;
  }
  &__body {
    color: $mine-shaft-color;
    max-height: 70vh;
    overflow-y: auto;
  }
  &__close,
  &__close:hover {
    background: transparent;
  }
  &__button {
    background: transparent;
    border: 1px solid #cccccc;
    border-radius: 5px;
    color: $mine-shaft-color;
    &:hover,
    &:active {
      color: $half-baked-color;
      border-color: $half-baked-color;
      background: transparent;
    }
  }
}
</style>
